import { padMaxWidth, phoneMaxWidth } from "@/assets/css/variable";
import { useMediaQuery } from "react-responsive";

export const useMediaSize = () => {
  const isPhoneMedia = useMediaQuery({
    maxWidth: phoneMaxWidth,
  });
  const isPadMedia = useMediaQuery({
    maxWidth: padMaxWidth,
  });

  return {
    isPhoneMedia,
    isPadMedia,
  };
};
